var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-checkbox',{attrs:{"name":"check-button","switch":""},model:{value:(_vm.enableCopy),callback:function ($$v) {_vm.enableCopy=$$v},expression:"enableCopy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }